module.exports = __webpack_public_path__ + "media/images/athletes/274-4711881b373ab345a2b22f757bf8731a.png";